export const isLatteAgency = () => {
  if (window.location.host === "fulfill.lattehub.com" || window.location.host === "fulfill.latteprint.com")
    return true;
}

export const isBambooAgency = () => {
  if (window.location.host === "fulfill.bambooz.io")
    return true;
}